import { Box, Stack, Text } from '@chakra-ui/react';
import { CandidateWithJobContextBasicInfo } from '@/types/Candidate';
import CircleProgressBar from '@/components/data-display/CircularProgressBar';
import { getJobCandidateStatusLabel } from '@/types/enums';
import { getCandidateFullName } from '@/utils';

interface CandidateCardProps {
  candidate: CandidateWithJobContextBasicInfo;
}

export function CandidateCard({ candidate }: CandidateCardProps) {
  const score = candidate.user_score.overall_score || candidate.overall_score;
  const lastWorkExperience =
    candidate?.resume_data?.work_experiences?.length > 0
      ? candidate.resume_data.work_experiences[0]
      : null;

  return (
    <Box
      cursor="pointer"
      bg="background.secondary"
      border="1px solid"
      borderColor="transparent"
      borderRadius="16px"
      p="8px 4px"
    >
      <Stack gap="4px" alignItems="center">
        <Box h="105px" w="105px">
          <CircleProgressBar value={score} />
        </Box>
        <Text fontWeight="semibold" fontSize="16px">
          {getCandidateFullName(candidate.first_name, candidate.last_name)}
        </Text>
        <Text color="neutrals.600" fontSize="12px" maxW="180px" textAlign="center">
          {lastWorkExperience
            ? `${lastWorkExperience?.job_role} @ ${lastWorkExperience?.company_name}`
            : 'No work experience'}
        </Text>
        <Box
          color="neutrals.500"
          fontSize="12px"
          maxW="180px"
          textAlign="center"
          bg="neutrals.100"
          p="4px 8px"
          borderRadius="8px"
        >
          {getJobCandidateStatusLabel(candidate.status)}
        </Box>
      </Stack>
    </Box>
  );
}
